import { useCallback } from "react";
import type { EmblaOptionsType, EmblaCarouselType } from "embla-carousel";

import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import { DotButton } from "./EmblaCarouselDotButton";
import { useDotButton } from "./useDotButton";

type PropType = {
	slides: Array<JSX.Element>;
	options?: EmblaOptionsType;
};

const EmblaCarousel: React.FC<PropType> = (props) => {
	const { slides, options } = props;
	const [emblaRef, emblaApi] = useEmblaCarousel(options, []);

	const onNavButtonClick = useCallback((emblaApi: EmblaCarouselType) => {
		const autoplay = emblaApi?.plugins()?.autoplay;
		if (!autoplay) return;
		const resetOrStop =
			autoplay.options.stopOnInteraction === false
				? autoplay.reset
				: autoplay.stop;
		resetOrStop();
	}, []);

	const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(
		emblaApi,
		onNavButtonClick
	);
 
	return (
		<section className="embla">
			<div ref={emblaRef} className="embla__viewport">
				<div className="embla__container">
					{slides.map((element, index) => (
						<div key={index} className="embla__slide__v2">
							{element}
						</div>
					))}
				</div>
			</div>

			<div className="flex justify-between">
				<div className="embla__controls w-full">
					<div className="embla__dots">
						{scrollSnaps.map((_, index) => (
							<DotButton
								key={index}
								className={"embla__dot".concat(
									index === selectedIndex ? " embla__dot--selected" : ""
								)}
								onClick={() => {
									onDotButtonClick(index);
								}}
							/>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};

export default EmblaCarousel;
